import { motion } from "framer-motion";
import { Phone, MessageCircle, FileText } from "lucide-react";
import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { telLink, waLink } from "@/lib/api";

const WhatsAppIcon = ({ className = "w-6 h-6" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor">
    <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.87 9.87 0 0 0 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2zm0 18.03a8.1 8.1 0 0 1-4.13-1.13l-.3-.18-3.07.81.82-3-.2-.31a8.08 8.08 0 1 1 6.88 3.81zm4.44-6.06c-.24-.12-1.44-.71-1.66-.79-.22-.08-.39-.12-.55.12-.16.24-.63.79-.77.95-.14.16-.28.18-.53.06-.24-.12-1.02-.38-1.95-1.2-.72-.64-1.2-1.43-1.35-1.68-.14-.24-.01-.37.11-.5.11-.11.24-.28.37-.42.12-.14.16-.24.24-.4.08-.16.04-.31-.02-.43-.06-.12-.55-1.32-.75-1.81-.2-.48-.4-.41-.55-.42h-.47c-.16 0-.43.06-.65.31-.22.24-.86.84-.86 2.05 0 1.21.88 2.37 1 2.53.12.16 1.72 2.63 4.18 3.69.58.25 1.04.4 1.4.52.59.19 1.12.16 1.54.1.47-.07 1.44-.59 1.64-1.16.2-.57.2-1.05.14-1.16-.06-.1-.22-.16-.46-.28z" />
  </svg>
);

export default function FloatingActions() {
  const { settings } = useSite();
  const wa = waLink(settings, "Hello ICROPSIA team, I would like to know more about your seeds.");

  return (
    <>
      <motion.a
        href={wa}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-float-button"
        aria-label="Chat on WhatsApp"
        initial={{ opacity: 0, scale: 0.6 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1.4, type: "spring", stiffness: 260, damping: 18 }}
        className="hidden md:flex fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white items-center justify-center shadow-xl shadow-[#25D366]/30 hover:scale-110 transition-transform"
      >
        <WhatsAppIcon />
      </motion.a>

      <div data-testid="mobile-action-bar" className="md:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-3 bg-white/95 backdrop-blur-md border-t border-brand-deep/10 shadow-[0_-4px_20px_rgba(20,83,45,0.08)]">
        <a href={telLink(settings)} data-testid="mobile-bar-call" className="flex flex-col items-center gap-1 py-2.5 text-brand-deep">
          <Phone className="w-5 h-5" />
          <span className="text-[10px] font-semibold tracking-wide">CALL</span>
        </a>
        <a href={wa} target="_blank" rel="noopener noreferrer" data-testid="mobile-bar-whatsapp" className="flex flex-col items-center gap-1 py-2.5 text-[#1da851]">
          <WhatsAppIcon className="w-5 h-5" />
          <span className="text-[10px] font-semibold tracking-wide">WHATSAPP</span>
        </a>
        <Link to="/contact" data-testid="mobile-bar-enquire" className="flex flex-col items-center gap-1 py-2.5 text-brand-gold">
          <FileText className="w-5 h-5" />
          <span className="text-[10px] font-semibold tracking-wide">ENQUIRE</span>
        </Link>
      </div>
    </>
  );
}
